import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import ConfirmationDialog from '../ConfirmationDialog';

interface NotLatestTestImportProps {
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
  context: 'history' | 'manual-treatment';
}

const NotLatestTestImport: React.FC<NotLatestTestImportProps> = ({
  open,
  onConfirm,
  onClose,
  context,
}) => {
  const getMessages = () => {
    if (context === 'history') {
      return {
        title: 'Attention - Base tampon ancienne',
        description: (
          <div className="space-y-3">
            <div className="mb-2 flex items-center gap-2 text-amber-600">
              <ExclamationTriangleIcon className="h-6 w-6" />
              <span className="font-semibold">Cette base tampon n'est pas la plus récente pour cette entreprise.</span>
            </div>
            <p className="text-sm text-gray-600">
              Vous vous apprêtez à consulter une base tampon plus ancienne pour cette entreprise. 
              Cela peut entraîner une confusion et des erreurs dans votre travail.
            </p>
            <p className="text-sm text-gray-600">
              Voulez-vous tout de même consulter cet import ?
            </p>
          </div>
        ),
        confirmLabel: 'Consulter quand même',
        cancelLabel: 'Annuler',
      };
    } 
      return {
        title: 'Attention - Base tampon ancienne',
        description: (
          <div className="space-y-3">
            <div className="mb-2 flex items-center gap-2 text-amber-600">
              <ExclamationTriangleIcon className="h-6 w-6" />
              <span className="font-semibold">Cette base tampon n'est pas la plus récente pour cette entreprise.</span>
            </div>
            <p className="text-sm text-gray-600">
              Vous vous apprêtez à travailler sur le traitement manuel d'une base tampon plus ancienne pour cette entreprise.
              Cela peut entraîner une confusion et des erreurs dans votre travail.
            </p>
            <p className="text-sm text-gray-600">
              Voulez-vous tout de même accéder au traitement manuel ?
            </p>
          </div>
        ),
        confirmLabel: 'Continuer',
        cancelLabel: 'Annuler',
      };
    
  };

  const messages = getMessages();

  return (
    <ConfirmationDialog
      open={open}
      title={messages.title}
      description={messages.description}
      confirmLabel={messages.confirmLabel}
      cancelLabel={messages.cancelLabel}
      onConfirm={onConfirm}
      onClose={onClose}
    />
  );
};

export default NotLatestTestImport;
